import { render, staticRenderFns } from "./CreatePDF.vue?vue&type=template&id=94687c02&scoped=true"
import script from "./CreatePDF.vue?vue&type=script&lang=js"
export * from "./CreatePDF.vue?vue&type=script&lang=js"
import style0 from "./CreatePDF.vue?vue&type=style&index=0&id=94687c02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94687c02",
  null
  
)

export default component.exports